import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { HomePath } from '../../home-path'

export default function Settings() {
  if (!localStorage.getItem('reloadGN')) {
    localStorage.setItem('reloadGN', 'true');
    window.location.reload();
}
  return (
    <div className="h-fit w-full py-12">
      <div className="mxw">
        <div className="w-full h-fit py-4 text-left">
            <p className="text-3xl font-bold">Settings</p>
        </div>
        <section className="">
          <ul className="space-y-2">
            <li className="flex items-center justify-between border-b border-b-gray-500 py-2 px-3">
              <p>Email</p>
              <p>yourname@abc.com</p>
            </li>
            <li className="flex items-center justify-between border-b border-b-gray-500 py-2 px-3">
              <p>Mobile Number</p>
              <p>1 500 123 4567</p>
            </li>
            <li className="flex items-center justify-between border-b-[12px] border-b-gray-400 py-2 px-3">
              <p>Date of birth</p>
              <p>10/2000</p>
            </li>
          </ul>

          <ul className="space-y-2">
            <li className="flex items-center justify-between border-b-[12px] border-b-gray-400border-b border-b-gray-400 py-2 px-3">
              <p>Notifications</p>
            </li>
          </ul>

          <ul className="space-y-2">
            <li className="flex items-center justify-between border-b border-b-gray-500 py-2 px-3">
              <p>Country/Origin</p>
              <p>Canada</p>
            </li>
            <li className="flex items-center justify-between border-b border-b-gray-500 py-2 px-3">
              <p>Store Language</p>
              <p>English UK</p>
            </li>
            <li className="flex items-center justify-between border-b border-b-gray-500 py-2 px-3">
              <p>Payment Information</p>
            </li>
            <li className="flex items-center justify-between border-b-[12px] border-b-gray-400 py-2 px-3">
              <p>Shipping Information</p>
            </li>
          </ul>
          
          <ul className="space-y-2">
            <a href={HomePath + "/privacy"} target="_blank" rel="noreferrer noopener">
              <li className="flex items-center justify-between border-b border-b-gray-400 py-2 px-3">
                <p className="font-semibold">Privacy</p>
                <p>Canada</p>
              </li>
            </a>
            <a href={HomePath + "/workout-info"} target="_blank" rel="noreferrer noopener">
              <li className="flex items-center justify-between border-b border-b-gray-400 py-2 px-3">
                <p className="font-semibold">Workout Info</p>
                <p>English UK</p>
              </li>
            </a>
            <li className="flex items-center justify-between border-b-[12px] border-b-gray-400 py-2 px-3">
              <p>Profile Visibility</p>
              <p>Everyone</p>
            </li>
          </ul>

          <ul className="space-y-2">
            <li className="flex items-center justify-between border-b border-b-gray-400 py-2 px-3">
              <p>Discover our brand</p>
            </li>
            <li className="flex items-center justify-between border-b border-b-gray-400 py-2 px-3">
              <p>Get Support</p>
            </li>
          </ul>
        </section>
      </div>
    </div>
  )
}
